import React, { useEffect, useRef, useState } from "react";
import AudioPlayer from "../../QuestionPage/AudioPlayer";
import WriteBox from "../../QuestionPage/WordBox";
import Timer from "../Timer";
import ExamPanel from "../ExamPanel";

export default function WriteFromDictationMockPage({
  question,
  onInputChange,
  questionNumber,
  maxQuestion,
}) {
  const [audioLink, setAudioLink] = useState("");
  const [text, setText] = useState("");
  const audioRef = useRef(null);

  useEffect(() => {
    const fetchSignedUrl = async () => {
      try {
        const res = await fetch(question.media_link);
        const data = await res.json();
        setAudioLink(data.url);
        if (audioRef.current) {
          audioRef.current.pause();
          audioRef.current.currentTime = 0;
        }
      } catch (err) {
        console.error("Failed to fetch signed audio URL:", err);
      }
    };

    if (question?.media_link) fetchSignedUrl();
  }, [question]);

  const handleTextChange = (newText) => {
    setText(newText);
    onInputChange(newText);
  };

  return (
    <ExamPanel
      eyebrow="Listening"
      title="Write From Dictation"
      questionLabel={`Question ${questionNumber} of ${maxQuestion}`}
      meta={
        <>
          Time left: <Timer initialMinutes={10} initialSeconds={0} />
        </>
      }
      instructions="You will hear a sentence. Type the sentence exactly as you hear it."
    >
      <div className="grid gap-5 lg:grid-cols-[minmax(280px,0.85fr),1.15fr] lg:items-start">
        <div className="space-y-4">
          <div className="rounded-md border border-slate-200 bg-slate-50 p-4">
            {audioLink ? (
              <AudioPlayer audioSrc={audioLink} audioRef={audioRef} />
            ) : (
              <p className="text-sm font-semibold text-gray-500">Loading audio...</p>
            )}
          </div>
        </div>

        <WriteBox
          onTextChange={handleTextChange}
          minHeight="min-h-[12rem]"
          title="Type what you hear"
          helper="Include every word in the sentence, in order."
          placeholder="Type the dictated sentence..."
        />
      </div>
    </ExamPanel>
  );
}
